import React, { useState, useRef, useCallback } from 'react';

// Wrapper que integra las dos versiones (barras desglosadas y apiladas al 100%)
// de un mismo gráfico anual, con un toggle similar al del Tablero V1 (Torta/Barras).
// El selector elige la variante visible; el header es único (título + subtítulo
// según la variante + botón descargar que usa la instancia del gráfico activo).
export const SelectorGraficoTipoSubsidio = ({
    titulo,
    subtituloActivo,
    GraficoDesglosado,
    GraficoApilado,
    data,
    anioSeleccionado,
    vistaInicial = 'apilado'
}) => {
    const [vista, setVista] = useState(vistaInicial);
    const instanciaRef = useRef(null);

    const onChartReady = useCallback((instancia) => {
        instanciaRef.current = instancia;
    }, []);

    const descargarGrafico = () => {
        const instancia = instanciaRef.current;
        if (!instancia) return;
        const url = instancia.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#fff' });
        const link = document.createElement('a');
        link.href = url;
        link.download = `${vista === 'apilado' ? 'Apilado' : 'Desglosado'}_${anioSeleccionado}.png`;
        link.click();
    };

    const esApilado = vista === 'apilado';

    return (
        <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm h-[450px] flex flex-col">
            <div className="flex justify-between items-start mb-4">
                <div>
                    <h3 className="text-base font-bold text-gray-800 tracking-tight uppercase">
                        {titulo}
                    </h3>
                    <p className="text-xs text-gray-400">
                        {subtituloActivo}
                    </p>
                </div>
                <div className="flex items-center gap-3">
                    {/* 🔁 Toggle Desglosadas / Apiladas */}
                    <div className="flex rounded-lg border border-gray-200 overflow-hidden">
                        <button
                            type="button"
                            onClick={() => setVista('desglosado')}
                            className={`px-3 py-1 text-xs font-medium transition-colors ${
                                !esApilado ? 'bg-blue-600 text-white' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                            }`}
                        >
                            Desglosadas
                        </button>
                        <button
                            type="button"
                            onClick={() => setVista('apilado')}
                            className={`px-3 py-1 text-xs font-medium transition-colors ${
                                esApilado ? 'bg-blue-600 text-white' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                            }`}
                        >
                            Apiladas
                        </button>
                    </div>
                    <button
                        type="button"
                        onClick={descargarGrafico}
                        title="Descargar gráfico como PNG"
                        className="flex items-center space-x-2 text-sm text-gray-600 cursor-pointer bg-gray-50 hover:bg-gray-100 px-3 py-1.5 rounded-md border border-gray-200 transition-colors select-none"
                    >
                        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3" />
                        </svg>
                        <span className="font-medium text-gray-700">Descargar</span>
                    </button>
                </div>
            </div>

            {esApilado ? (
                <GraficoApilado
                    data={data}
                    anioSeleccionado={anioSeleccionado}
                    soloChart
                    onChartReady={onChartReady}
                />
            ) : (
                <GraficoDesglosado
                    data={data}
                    anioSeleccionado={anioSeleccionado}
                    soloChart
                    onChartReady={onChartReady}
                />
            )}
        </div>
    );
};